
import React from 'react';
import { Button } from '@/components/ui/button';
import { NavigateFunction } from 'react-router-dom';
import { DialogueItem } from './types';

export interface HeaderInfoProps {
  item: DialogueItem;
  navigate: NavigateFunction;
}

export const HeaderInfo: React.FC<HeaderInfoProps> = ({ item, navigate }) => {
  const { faithGroup } = item.content;
  
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <h3 className="text-xl font-medium text-heaven-gold text-left">
          Your Response
        </h3>
        
        <div className="bg-heaven-gold/5 p-4 rounded-md text-left">
          <div>
            <span className="font-semibold text-heaven-gold">Faith Group:</span>
            <span className="ml-2 text-gray-700">{faithGroup}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const NavigationButton: React.FC<HeaderInfoProps> = ({ navigate }) => {
  return (
    <div className="mt-8 flex justify-start">
      <Button
        variant="outline"
        className="border-heaven-gold text-heaven-gold hover:bg-heaven-gold/10"
        onClick={() => navigate('/apologetics/interfaith-dialogue')}
      >
        Ask Another Question
      </Button>
    </div>
  );
};
